import { Card } from 'antd'
import { IconZone } from './IconZone'

import { displayMessage } from '../../../../helpers/messages'
import './sector-map.css'

export const SectorMap = ({ img, sector, height, width }) => {
    return sector ? (
        <div className="flex justify-center items-center">
            <Card className="zone--box p-0 bg-white">
                <div id="imageDiv" class="zoneimg h-full relative">
                    <img
                        id="checkCoordinates"
                        className="zoneimg"
                        // style="!colorfulFloorPlan ? 'filter: grayscale(100%)' : ''"
                        // style={{ filter: 'grayscale(100%)' }}
                        src={img}
                        height={height}
                        width={width}
                        atl={sector?.name || '-'}
                    />

                    {sector?.devices.map((device, index) => {
                        const absoluteX = device?.positionX * width
                        const absoluteY = device?.positionY * height

                        return <IconZone key={`${index}-iconzone`} deviceInfo={device} absoluteX={absoluteX} absoluteY={absoluteY} iconSize="large" />
                    })}
                </div>
            </Card>
        </div>
    ) : (
        <div className="flex justify-center items-center w-full central-no-centrals-text" style={{ height }}>
            {' '}
            {displayMessage('NO_SECTORS')}
        </div>
    )
}
